import View from './view.js';

export default class Header extends View {
  get dom() {
    return {
      CUSTOMER_SELECT: '.customer-change-select',
    };
  }

  initialize() {
    this.$('.select2-container').remove();
    this.$(this.dom.CUSTOMER_SELECT).select2();
  }

  events() {
    var events = {};
    events['change ' + this.dom.CUSTOMER_SELECT] = '_changeCustomer';
    return events;
  }

  _changeCustomer(e) {
    var $target = $(e.currentTarget);

    window.location =
      window.location.protocol +
      '//' +
      window.location.host +
      '/' +
      $target.val() +
      '/root_redirect';
  }
}
